/* =====================================================================
   INVENI — UNIVERSAL COLLECTION + SEARCH PAGE JS
   - Uses EVENT DELEGATION so it survives Shopify AJAX refreshes
   - Supports:
       1. Collection: Grid / Micro / List (bisac)
       2. Search Page: Grid / Micro / List (inveniSearch)
       3. Tab switchers (Best Sellers, New Releases, Coming Soon)
===================================================================== */

(function () {

  /* ============================================================
     A) UNIVERSAL EVENT-DELEGATED LAYOUT TOGGLE
     Works even after Shopify replaces DOM (filters/sort/pagination)
  ============================================================ */
  document.addEventListener("click", function (event) {
    const btn = event.target.closest(".inveni-layout-toggle");
    if (!btn) return;

    const mode = btn.dataset.mode;
    if (!mode) return;

    // Identify whether it's search or collections
    const isSearch = !!document.querySelector("#inveniSearchLayoutToggle");
    const isBisac = !!document.querySelector("#bisacLayoutToggle");

    const container =
      document.querySelector("#inveniSearchLayoutContainer") ||
      document.querySelector("#bisacLayoutContainer");

    if (!container) return;

    // Update active states
    document.querySelectorAll(".inveni-layout-toggle").forEach((b) =>
      b.classList.remove("active")
    );
    btn.classList.add("active");

    // Apply new layout class
    container.classList.remove(
      "inveni-grid--grid",
      "inveni-grid--micro",
      "inveni-grid--list"
    );
    container.classList.add(`inveni-grid--${mode}`);

    // Save state separately for search or bisac
    if (isSearch)
      localStorage.setItem("inveni-search-layout-mode", mode);
    if (isBisac)
      localStorage.setItem("inveni-bisac-layout-mode", mode);
  });

  /* ============================================================
     B) RESTORE SAVED LAYOUT ON PAGE LOAD
  ============================================================ */
  document.addEventListener("DOMContentLoaded", function () {
    const searchMode = localStorage.getItem("inveni-search-layout-mode");
    const bisacMode = localStorage.getItem("inveni-bisac-layout-mode");

    const container =
      document.querySelector("#inveniSearchLayoutContainer") ||
      document.querySelector("#bisacLayoutContainer");

    const mode = searchMode || bisacMode || "grid";

    if (container) {
      container.classList.add(`inveni-grid--${mode}`);
    }

    const activeBtn = document.querySelector(
      `.inveni-layout-toggle[data-mode="${mode}"]`
    );
    if (activeBtn) activeBtn.classList.add("active");
  });

  /* ============================================================
     C) TAB SWITCHER (Best Sellers, Coming Soon, New Releases)
  ============================================================ */
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".inveni-filter-toggle");
    if (!btn) return;

    const group = btn.closest(".inveni-toggle-group");
    if (!group) return;

    const container = group.nextElementSibling;
    if (!container) return;

    const target = btn.dataset.target;
    if (!target) return;

    group.querySelectorAll(".inveni-filter-toggle").forEach((b) =>
      b.classList.remove("active")
    );
    btn.classList.add("active");

    container.querySelectorAll(".inveni-tab-content").forEach((panel) =>
      panel.classList.remove("active")
    );

    const panel = container.querySelector("#" + target);
    if (panel) panel.classList.add("active");
  });

})();
